import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976D2",
    },
    secondary: {
      main: "#9e9e9e",
    },
    info: {
      main: "#808080ff",
    },
    text: {
      primary: "rgba(0, 0, 0, 0.95)",
      secondary: "rgba(0, 0, 0, 0.75)",
      disabled: "rgba(0, 0, 0, 0.45)",
    },
  },
});

export default theme;
